export default __webpack_public_path__ + "static/media/success.46c46553.svg";